import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 18 10" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M15.788 4.465l-3.14-3.11.704-.71 4.355 4.314-4.352 4.393-.71-.704 3.153-3.183L1.001 5.5 1 4.5l14.789-.035z" /></svg>;